import { SELECTED_BRANCH_KEY } from "../components/modal/branchModal";

export function getCurrentWarehouse() {
  const savedBranch = localStorage.getItem(SELECTED_BRANCH_KEY);
  const branch = savedBranch ? JSON.parse(savedBranch) : null;
  return branch;
}
